import {
  TEAM_MENTION_REGEX_STR,
  USER_MENTION_REGEX_STR,
} from "@mapmycustomers/shared/util/consts/mentions";

export const MENTION_LETTER_OFFSET = 24;

export const MENTIONS_REGEXP = new RegExp(
  `${USER_MENTION_REGEX_STR}|${TEAM_MENTION_REGEX_STR}`,
  "g"
);
